import { Flex, Text, Badge, Spacer } from '@chakra-ui/react'
import { FC, useMemo } from 'react'

import useParametrizationConfigPurchase from '@hook/parametrization/use-config-purchase'

import { canManagePurchaseApprovalRules } from '@helper/parametrization/purchaseConfigAuth'

import ModalCreateAlcada from './Alcada/ModalCreateAlcada'
import ParametrizationAlcadaPurchasetModalDelete from './Alcada/ModalDeleteAlcada'
import ModalUpdateAlcada from './Alcada/ModalUpdateAlcada'

const SelectedTableBarReabCronPurchaseAlcada: FC = () => {
  const { selectedAlcada } = useParametrizationConfigPurchase()
  // Só controle de interface: a API também precisa validar o perfil
  const canManage = useMemo(() => canManagePurchaseApprovalRules(), [])

  return (
    <Flex
      borderBottom="solid 1px"
      borderColor="gray.200"
      alignItems="center"
      justifyContent="space-between"
      paddingY={2}
      paddingX={4}
    >
      <Flex alignItems="center">
        <Badge
          h="16px"
          minW="16.5px"
          marginRight={2}
          ml="1"
          color="#4b64c9"
          border="1px solid #4b64c9"
          background="#c0d9ff"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {selectedAlcada !== 0 ? 1 : 0}
        </Badge>
        <Text color={'black'}>Itens Selecionados</Text>
      </Flex>

      <Spacer />

      {!canManage ? (
        <Text fontSize="sm" color="gray.500">
          Somente visualização (criação/edição restrita a Administrador e
          Diretor)
        </Text>
      ) : selectedAlcada !== 0 ? (
        <>
          <ParametrizationAlcadaPurchasetModalDelete />
          <ModalUpdateAlcada />
        </>
      ) : (
        <ModalCreateAlcada />
      )}
    </Flex>
  )
}

export default SelectedTableBarReabCronPurchaseAlcada
